import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { formatDateMMDDYYYY } from '../../../../services/date-time.service';
const AttendanceRow = ({ data, displayModal, disableSelection, ...props }) => {
    const hoverEffect = disableSelection
        ? ''
        : 'cursor-pointer hover:bg-slate-200';
    const tableRowOnClick = () => {
        if (!disableSelection)
            displayModal(data);
    };
    const startDate = formatDateMMDDYYYY(data.startDate);
    const endDate = formatDateMMDDYYYY(data.endDate);
    return (_jsx(Fragment, { children: _jsxs("tr", { className: `flex border border-x-0 ${hoverEffect}`, onClick: tableRowOnClick, children: [_jsx("td", { className: "w-5/12 min-w-36 p-3 text-left font-normal text-cssText", children: data.workshopName }), _jsx("td", { className: "w-2/12 min-w-36 p-3 text-left font-normal text-cssText", children: startDate }), _jsx("td", { className: "w-2/12 min-w-36 p-3 text-left font-normal text-cssText", children: endDate }), _jsx("td", { className: "w-2/12 min-w-36 p-3 text-left font-normal text-cssText", children: data.hoursType }), _jsx("td", { className: "w-1/12 p-3 text-left font-normal text-cssText", children: data.hoursLogged })] }) }));
};
export default AttendanceRow;
